import React from 'react';
import classNames from 'classnames';
import { NavItem, NavLink } from 'reactstrap';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import { CountBadge } from '@/components/CountBadge';
import { TooltipWrapper } from '@/components/TooltipWrapper';
import styles from './SidebarNavRow.module.scss';

// A single sidebar nav row — icon, label, optional unread-count badge, and
// active/collapsed styling. Every nav link in the sidebar (switch-view,
// overview, monitor, management, administration) renders through this one
// component so the row markup and states only exist in one place.
export const SidebarNavRow = ({
  itemId,
  icon: Icon,
  label,
  active,
  badgeCount,
  collapsed,
  onClick,
}) => {
  const row = (
    <NavItem id={itemId} className="cursor-pointer">
      <NavLink
        onClick={onClick}
        className={classNames(styles.navRow, {
          [styles.navRow_active]: active,
          [styles.navRow_collapsed]: collapsed,
        })}
      >
        <span
          className={classNames(styles.navRowIndicator, {
            [styles.navRowIndicator_active]: active,
          })}
        />
        {Icon && <Icon size={18} className={styles.navRowIcon} />}
        {!collapsed && (
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={
              active ? fontWeightEnum.Semibold : fontWeightEnum.Medium
            }
            className={styles.navRowLabel}
            style={{ caretColor: 'transparent' }}
          >
            {label}
          </Text>
        )}
        {!collapsed && (
          <CountBadge count={badgeCount} className={styles.navRowBadge} />
        )}
      </NavLink>
    </NavItem>
  );

  if (!collapsed) return row;

  return (
    <TooltipWrapper tooltip={label} tooltipPlacement="right">
      {row}
    </TooltipWrapper>
  );
};

SidebarNavRow.displayName = 'SidebarNavRow';
